<template>
  <div ref="host" class="host vm-video-side">
    <div class="vm-video-side-header">
      <button class="vm-exit-button">
        <i class="material-icons">exit_to_app</i>
      </button>
      <div class="vm-videochat-search-wrap">
        <input
          placeholder="Поиск..."
          class="vm-videochat-search"
          type="text"
        />
      </div>
      <div class="vm-buttons">
        <button @click="toggleVideo()" class="vm-action-button">
          <i class="material-icons">videocam</i>
        </button>
        <button @click="toggleAudio()" class="vm-action-button">
          <i class="material-icons">mic</i>
        </button>
        <button class="vm-action-button">
          <i class="material-icons">tv</i>
        </button>
      </div>
    </div>
    <div class="vm-video-side-main">
      <div class="vm-video-contacts">
        <VideoComponent
          v-for="frame in frames"
          :key="frame.subscriber.stream.connection.connectionId"
          :streamManager="frame.subscriber"
          :username="frame.username"
        />
      </div>
      <div class="vm-video-viewer">
        <div class="vm-video-viewer-content">
          <div class="vm-video-frame" ref="mainframe">
            <VideoComponent
              v-if="activeFrame"
              large
              @exitFullscreen="toggleFullscreen"
              :fullscreen="fullscreen"
              :streamManager="activeFrame.subscriber"
              :username="activeFrame.username"
            />
          </div>
        </div>
        <div class="vm-video-viewer-footer">
          <div class="vm-video-control-block">
            <div class="vm-video-range">
              <i class="material-icons">volume_down</i>
              <b-form-input type="range" min="0" max="200"></b-form-input>
              <i class="material-icons">volume_up</i>
            </div>
            <div class="vm-buttons">
              <button class="vm-action-button">
                <i class="material-icons">videocam</i>
              </button>
              <button class="vm-action-button">
                <i class="material-icons">volume_mute</i>
              </button>
              <button class="vm-action-button">
                <i class="material-icons">mic</i>
              </button>
              <button @click="toggleFullscreen" class="vm-action-button">
                <i class="material-icons">fullscreen</i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoComponent from './VideoComponent';

export default {
  components: {
    VideoComponent
  },
  props: {
    frames: Array,
    activeFrame: Object
  },
  data: () => ({
    fullscreen: false
  }),
  mounted() {
    this.$refs.mainframe.onfullscreenchange = event => this.fullscreen = !this.fullscreen;
  },
  methods: {
    toggleAudio() {
    },
    toggleVideo() {
    },
    toggleFullscreen() {
      if (this.fullscreen) {
        document.exitFullscreen();
      } else {
        this.$refs.mainframe.requestFullscreen();
      }
    }
  }
};
</script>

<style scoped>
.host.vm-video-side {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vm-video-side-header {
  height: 60px;
  flex: 0 0 60px;
  display: flex;
  border-bottom: 1px solid rgba(255,255,255,.8);
}
.vm-video-side-main {
  height: calc(100% - 60px);
  display: flex;
}
.vm-video-contacts {
  /* background-color: red; */
  width: 150px;
  flex: 0 0 150px;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
}
.vm-video-contacts-header {
  height: 60px;
  flex: 0 0 60px;
}
.vm-video-contacts-content {
  height: 100%;
  overflow-y: auto;
}
.vm-video-viewer {
  border-left: 1px solid rgba(255,255,255,.8);
  flex: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.vm-video-viewer-header {
  display: none;
}
.vm-video-viewer-footer {
  flex: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
.vm-video-frame {
  display: flex;
}
.vm-video-side img {
  display: block;
  width: 100%;
}
/* scroll */
::-webkit-scrollbar {
  width: 10px;
}
::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.3);
}
::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2);
}
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
/* header main */
.vm-video-contacts-header {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.vm-videochat-search-wrap {
  padding: 12px;
  padding-left: 0;
  width: 240px;
}
.vm-videochat-search {
  display: block;
  border: 0;
  background-color: rgba(255, 255, 255, 0.1);
  border-radius: 4px;
  width: 100%;
  color: #fff;
  padding-left: 24px;
  height: 36px;
  outline: none;
}
.vm-videochat-search::placeholder {
  color: #fff;
  font-weight: 300;
}
.vm-exit-button {
  border: 0;
  background-color: transparent;
  color: #fff;
  outline: 0;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 0 0 60px;
}
.vm-exit-button i {
  transform: rotate(180deg);
  font-size: 36px;
}
.vm-video-control-block {
  width: 100%;
  padding: 24px;
}
.vm-video-range {
  display: flex;
  width: 100%;
  align-items: center;
}
.vm-video-range i {
  margin: 12px;
  color: #fff;
}
input[type=range] {
  outline: 0;
}
input[type=range]::-webkit-slider-thumb {
  background-color: white;
  box-shadow: 0 0 5px 2px rgba(0,0,0,0.3);
}
.vm-buttons {
  display: flex;
  justify-content: center;
}
.vm-video-side-header {
  align-items: center;
}
.vm-video-side-header .vm-buttons {
  margin-left: auto;
}
.vm-video-side-header .vm-buttons .vm-action-button {
  height: 42px;
  width: 42px;
}
.vm-action-button {
  outline: 0;
  background-color: rgba(255,255,255,.1);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 0;
  border-radius: 50%;
  height: 48px;
  width: 48px;
  margin: 6px;
}
</style>
